import moment from "moment";
import sportIcons from '../assets/images/sports'
import * as PR from "../prime-react/index";
import { eventIcon } from "../assets/images/index";
import { newsTypes, RAW_FILTER_DATA } from "../shared/common";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DOMPurify from "dompurify";
import subDays from 'date-fns/subDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import { maxDate } from "../modules/Analyst/AlertPlatform/graph-and-stats/GraphConfig";

export const secretKey = "u+DSafjsklFSDA23asdfjl1234f==";
export const toastDisplayTime = 3000;
export const queryLimit = 50;
export const filenameLimit = 50;
export const rowsPerPage = [20, 50, 100]
export const maxNumberOfFiles = +process.env.REACT_APP_MAX_NUMBER_OF_FILES
export const pagecount = +process.env.REACT_APP_PAGE_COUNT;
export const chatCount = +process.env.REACT_APP_CHAT_COUNT;
export const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL
export const resendOtpTime = +process.env.REACT_APP_RESEND_OTP_TIME;
export const descriptionCount = +process.env.REACT_APP_DESCRIPTION_COUNT;
export const anomaliesScreenEnabled = process.env.REACT_APP_ENABLE_ANOMALIES_SCREEN === "true";
export const displayStatesForSelectedCountries = ["United States of America", "Canada"]
export const usLocationIds = [238];
export const privacyPolicyLink = '/policies/IBIA_Privacy_Notice.pdf';
export const termsAndConditionsLink = '/policies/IBIA_Code_of_Conduct.pdf'
export const aletFormForValidation = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
export const fileTypesConfig = [
  "application/zip",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
export const chatFileTypesConfig = [
  'application/pdf', 
  'text/csv', 
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
  'application/msword', 
  'application/vnd.ms-excel', 
  'image/png', 
  'image/jpeg'
];
export const newsFileTypesConfig = [
  "application/zip",
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
  "image/gif"
];
export const reportsFileTypesConfig =  [
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
export const allFileSupportedFormats = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "image/png",
  "image/jpg",
  "image/jpeg"
];
export const fileUploadLimit = {
  label: process.env.REACT_APP_MAX_FILE_SIZE_LABEL,
  value: +process.env.REACT_APP_MAX_FILE_SIZE_VALUE,
}

export const formatNumber = (number) => {
  return number < 10 ? `0${number}` : number;
};

export const getQueryString = (obj) => {
  const queryString = Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");
  return queryString;
};

export const formatDate = (dateString) => {
  const currentDate = new Date(dateString);

  // Extract components
  const optionsDate = {
    month: "long",
    day: "2-digit",
    year: "numeric",
  };
  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  };

  const formattedDate = currentDate.toLocaleDateString("en-US", optionsDate);
  const formattedTime = currentDate.toLocaleTimeString("en-US", optionsTime);

  const finalDate = {
    displayDate: formattedDate,
    displayTime: `${formattedTime} UTC`,
  };

  return finalDate;
};

export const formatTime = (date) => {
  const currentDate = new Date(date);
  const options = { hour: "numeric", minute: "2-digit", hour12: true };
  return <strong style={{fontWeight:"inherit"}} title={moment(date).utc().format("MMMM DD, YYYY HH:mm [UTC]")} >{currentDate
    .toLocaleTimeString("en-US", options)
    .replace(/\bAM\b/, "am")
    .replace(/\bPM\b/, "pm")}</strong>
};

export const DateFormat = (dateString) => {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return <strong style={{fontWeight:"inherit"}} title={moment(dateString).utc().format("MMMM DD, YYYY HH:mm [UTC]")} >{new Date(dateString)
    .toLocaleDateString("en-GB", options)
    .replace(/ /g, " ")}</strong>
};

export const dateTimeFormat = payload => <div title={moment(payload).utc().format("MMMM DD, YYYY HH:mm [UTC]")}>{DateFormat(payload)}, {formatTime(payload)}</div>
export const DateFormatComma = (dateString) => {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return <strong style={{fontWeight:"inherit"}} title={moment(dateString).utc().format("MMMM DD, YYYY HH:mm [UTC]")} >{new Date(dateString)
    .toLocaleDateString("en-GB", options)
    .replace(/ /g, " ")},</strong>
};
export const dateTimeFormatComma = payload => <div title={moment(payload).utc().format("MMMM DD, YYYY HH:mm [UTC]")}>{DateFormatComma(payload)} {formatTime(payload)}</div>

export const formatShortDate = (dateString) => {
  const date = moment(dateString);

  const formattedDate = date.format("DD MMM YYYY");

  return formattedDate;
};

export const formatDateRange = (dateString) => {
  if (dateString === "" || dateString === undefined) {
    return undefined;
  }
  const date = moment(dateString);

  // Format the date
  const formattedDate = date.format("YYYY-MM-DD");

  return formattedDate;
};
export const defaultDateRange = [
  new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  new Date()
];
export const defaultPlayerDateRange = [
  new Date(new Date().setFullYear(new Date().getFullYear() - 2)), // exactly 2 years ago from today
  new Date() // today
];
const normalize = (d) => {
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

export const areDateRangesEqual = (range1, range2) => {
  if (!range1 || !range2) return false;
  if (range1.length !== 2 || range2.length !== 2) return false;

  return (
    normalize(range1[0]) === normalize(range2[0]) &&
    normalize(range1[1]) === normalize(range2[1])
  );
};

export const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};


export const getRoleIds = (role) => {
  const roleMap = {
    member: [1, 2],
    analyst: [1, 2],
    regulator: 3,
    governingbody: 4,
    managedmember: [1, 2],
  };

  return roleMap[role] || null;
};

export const categoryColors = {
  "League Updates ": "red-color",
  "Regulatory Changes ": "green-color",
  "Industry Insights ": "blue-color",
  "Event Previews ": "purple-color",
  "Policy Reminders ": "yellow-color",
  "Educational Resources ": "green-color",
};
export const typeFilter = [
  { id: "1", name: "suspicious betting" },
  { id: "2", name: "summary" },
  { id: "3", name: "others" },
];

export const newsTitleChar = 95;

export const truncateText = (text, maxLength) => {
  if (text?.length > maxLength) {
    return text?.slice(0, maxLength) + "...";
  }
  return text;
};

// Normalize text: collapse multiple spaces, trim, and lowercase for consistent comparisons
export const normalizeText = (s) => {
  if (s === undefined || s === null) return '';
  return s.toString().replace(/\s+/g, ' ').trim().toLowerCase();
};

export const capitalizeFirstLetterOfEachSentence = (string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

export const getSportIcon = (sport) => {
  if (sportIcons[sport]) {
    const SportIcon = sportIcons[sport]
    return (SportIcon)
  } else {
    return (<PR.Image src={eventIcon} alt="Sport" />)
  }
}

export const getNewsTypeLabel = (newsType) => {
  return newsTypes?.filter(type => type.id === newsType)[0]?.name;
}

export const getStatusLabel = (status) => {
  return RAW_FILTER_DATA.caseStatus?.filter(type => type.id === status)[0]?.name;
}

export const sortAlerts = (alerts) => {
  return alerts?.sort((a, b) => {
    // Define sorting priorities
    const priority = (alert) => [
      (alert.alertStatus === "open" && alert?.responseRequired) ? 0 : 1, // 0 if responseRequired, 1 otherwise
      (alert.alertStatus === "evaluating" && alert?.responseRequired) ? 0 : 1,
      (alert?.activeConversation) ? 0 : 1, // 0 if activeConversation, 1 otherwise
      alert?.alertStatus === "open" ? 0 : (alert?.alertStatus === "evaluating" ? 1 : 2), // 0 if "open", 1 if "evaluating", 2 otherwise
      alert?.caseStatus === 'under investigation' ?-1:1,
      alert?.caseStatus === 'sanctioned' ?-1:1,
      alert?.caseStatus === 'closed' ?-1:1,
      alert?.alertStatus === 'not reported' ?-1:1
    ];

    // Compare based on the defined priorities
    const aPriority = priority(a);
    const bPriority = priority(b);

    return aPriority
    ?.map((val, index) => val - bPriority[index])
    ?.find(diff => diff !== 0) || 0; // find the first non-zero difference or return 0 if all are equal
  });
};

export const optionsforBarGraphs = {
  plugins: { 
      legend: false,
  },
  scales: {
      x: {
          grid: {
              display: false
          },
          ticks: {
            autoSkip: false,   // Show all labels, regardless of their length
            maxRotation: 60,   // Rotate labels to 60 degrees
            minRotation: 60,    // Keep consistent rotation angle
            callback: function(value) {
              const label = this.getLabelForValue(value);
              return label.length > 20 
                  ? label.slice(0, 20) +'...'
                  : label;
          }
        }
      },
      y: {
          grid: {
              color: '#D1DCD3',
          },
          border: {
              dash: [5, 6],
          },
          ticks: {
            stepSize: 1
          }
      }
  }
};
export const optionsforBarGraphsStaked = {
  ...optionsforBarGraphs,  
  maintainAspectRatio: false,
  aspectRatio: 0.8,             
  plugins: {
    ...optionsforBarGraphs.plugins,
    tooltip: {
      mode: 'index',
      intersect: false,
    },
  },
  scales: {
    ...optionsforBarGraphs.scales,
    x: {
      ...optionsforBarGraphs.scales.x,
      stacked: true,
    },
    y: {
      ...optionsforBarGraphs.scales.y,
      stacked: true,
    }
  }
};
export const optionsforBarGraphsStakedDetails = {
  ...optionsforBarGraphs,  
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
    ...optionsforBarGraphs.plugins,
    tooltip: {
      mode: 'index',
      intersect: false,
    },
  },
  scales: {
    ...optionsforBarGraphs.scales,
    x: {
      ...optionsforBarGraphs.scales.x,
      stacked: true,
       ticks: {
        font: {
          style: 'normal',
        },
      },
    },
    y: {
      ...optionsforBarGraphs.scales.y,
      stacked: true,
       ticks: {
        font: {
          style: 'normal',
        },
      },
    }
  }
};
export const optionsforBarGraphsDetails = {
  ...optionsforBarGraphs,
  maintainAspectRatio: false,
  scales: {
    ...optionsforBarGraphs.scales,
    x: {
      ...optionsforBarGraphs.scales.x,
      ticks: {
        font: {
          style: 'normal',
        },
      },
    },
  },
};

export const optionsforBarGraphsWithPercentage = {
  plugins: { 
      legend: false,
  },
  scales: {
      x: {
          grid: {
              display: false
          },
          ticks: {
            autoSkip: false,   // Show all labels, regardless of their length
            maxRotation: 60,   // Rotate labels to 60 degrees
            minRotation: 60,    // Keep consistent rotation angle
            callback: function(value) {
              const label = this.getLabelForValue(value);
              return label.length > 20 
                  ? label.slice(0, 20) +'...'
                  : label;
          }
        }
          
      },
      y: {
          grid: {
              color: '#D1DCD3',
          },
          border: {
              dash: [5, 6],
          },
          ticks: {
              stepSize: 20,
              callback: function(value) {
                  return `${value} %`;
              }
          }
      }
  }
};

export const optionsforBarGraphsWithPercentageDetails = {
  ...optionsforBarGraphsWithPercentage,
  maintainAspectRatio: false, // Adding this property here
  scales: {
    ...optionsforBarGraphsWithPercentage.scales,
    x: {
      ...optionsforBarGraphs.scales.x,
      ticks: {
        font: {
          style: 'normal',
        },
      },
    },
  },
};


export const optionsforResponseType = {
  plugins: { legend: false },
  indexAxis: 'y',
  aspectRatio: 0.8,
  responsive: true,
  maintainAspectRatio: false,
  scales: {
      x: {
          stacked: true,
          ticks: { display: false },
          grid: { display: false },
          border: { display: false }
      },
      y: {
          stacked: true,
          ticks: { display: false },
          grid: { display: false },
          border: { display: false }
      }
  }
};
export const analystChartTitles = {
  tarm: {
    title: 'Total Alerts Raised',
    description: 'The number of total alerts raised and deemed suspicious by each organisation in the given date range',
    fileName:'total-alerts-raised-by-member',
  },
  rrpm: {
    title: 'Response Rate',
    description: 'The % of alerts responded to by each organisation in the given date range',
    fileName:'response-rates-by-members'
  },
  taps:{
    title: 'Total Alerts by Sport',
    description: 'The number of total alerts raised and deemed suspicious by sport in a given date range',
    fileName:'total-alerts-by-sports'
  },
  tapl:{
    title: 'Total Alerts by Location',
    description: 'The number of alerts deemed suspicious by event location in a given date range',
    fileName:'total-alerts-by-locations'
  },
  tpc:{
    title: 'Tennis Players of Concern',
    description: 'Tennis players that have featured in multiple IBIA alerts deemed suspicious in a given date range',
    fileName:'tennis-players-of-concern'
  },
  pcps:{
    title: 'Athletes/Teams of Concern',
    description: 'Athletes/Teams that have featured in 2 or more deemed suspicious alerts',
    fileName:'athletes-teams-of-concern'
  },
  mcps:{
    title: 'Markets of Concern',
    description: 'Markets that have featured in 2 or more deemed suspicious alerts',
    fileName:'markets-of-concern'
  },
  rspr:{
    title: 'Reports Sent Regulators/SGBs',
    description: 'Reports shared with selected Regulators/Sport Governing Body in a given date range',
    fileName:'reports-sent-regulators-SGBs'
  },
  arps:{
    title: 'Alerts raised per sport by member',
    description: 'The number of alerts raised per sport by selected member in a given date range',
    fileName:'reports-sent-regulators-SGBs'
  },
  srpa:{
    title: 'Suspicious betting report',
    description: 'List of regulators and SGB who received a suspicious betting report for a given alert-ID',
    fileName:'suspicious-betting-report'
  },
  suspiciousAlert: {
    title: 'Suspicious alerts raised by member',
    description: 'Total alerts raised by member for suspicious alerts in the given date range',
    fileName: 'suspicious-alerts-raised-by-member',
  },
}
export const memberAnalystChartTitles = {
  arps: {
    heading: 'Alert raised',
    title: 'Alerts Raised by Sport',
    description: 'The number of alerts raised by your organisation by sport in a given date range',
    fileName:'alert-raised',
  },
  rtps: {
    heading: 'Response Type',
    title: 'Response Type',
    description: 'A breakdown (in %) of the way in which your organisation has responded to alerts in a given date range',
    fileName:'response-type',
  },
  rrps: {
    heading: 'Response Rate',
    title: 'Response Rate by Sport',
    description: 'The % of alerts responded to by your organisation by sport in a given date range',
    fileName:'response-rates',
  },
  taps:{
    heading: 'Total Alerts by Sport',
    title: 'Total Alerts by Sport',
    description: 'The number of total alerts raised and deemed suspicious by sport in a given date range',
    fileName:'total-alerts'
  },
  tapl:{
     heading: 'Total Alerts by Location',
    title: 'Total Alerts by Location',
    description: 'The number of alerts deemed suspicious by event location in a given date range',
    fileName:'alerts-by-location'
  },
  tpc:{
    heading: 'Tennis Players',
    title: 'Tennis Players of Concern',
    description: 'Tennis players that have featured in multiple IBIA alerts deemed suspicious in a given date range',
    fileName:'tennis-players'
  },
  pcps:{
    title: 'Athletes/Teams of Concern',
    description: 'Athletes/Teams that have featured in 2 or more deemed suspicious alerts',
    fileName:'athletes-teams-of-concern'
  },
  mcps:{
    title: 'Markets of Concern',
    description: 'Markets that have featured in 2 or more deemed suspicious alerts',
    fileName:'markets-of-concern'
  }
}
export const graphOptionsMap = {
  tarm: {
    normal: optionsforBarGraphsStaked,
    detail: optionsforBarGraphsStakedDetails,
  },
  rrpm: {
    normal: optionsforBarGraphsWithPercentage,
    detail: optionsforBarGraphsWithPercentageDetails,
  },
  taps: {
    normal: optionsforBarGraphsStaked,
    detail: optionsforBarGraphsStakedDetails,
  },
  tapl: {
    normal: optionsforBarGraphs,
    detail: optionsforBarGraphsDetails,
  },
  rrps: {
    normal: optionsforBarGraphsWithPercentage,
    detail: optionsforBarGraphsWithPercentageDetails,
  },
  tpc: {
    normal: optionsforBarGraphs,
    detail: optionsforBarGraphsDetails,
  },
  arps: {
    normal: optionsforBarGraphsStaked,
    detail: optionsforBarGraphsStakedDetails,
  },
  pcps: {
    normal: optionsforBarGraphs,
    detail: optionsforBarGraphsDetails,
  },
  mcps: {
    normal: optionsforBarGraphs,
    detail: optionsforBarGraphsDetails,
  },
};
export const  formatResponseTypeLabel = {
  "suspicious": "Suspicious",
  "notoffered": "Not Offered",
  "notsuspicious": "Not Suspicious"
}
// Function to captilize the first letter 
export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const remainingCharacters = (chatCount, fieldValue) => {
  const usedCharacters = getPlainText(fieldValue) || 0;
  const remainingCount = Math.max(chatCount - usedCharacters, 0);
  return `Remaining Characters: ${remainingCount}`;
};

export const permission ={
news: 3,
reports:4

}

export const roleIds = {
  regulator: 3,
  governingbody: 4,
  member: 2,
  managedmember:5
}

// Function to remove null values and empty arrays
export const cleanData = (data) => {
  if (Array.isArray(data)) {
    const cleanedArray = data
      .map(cleanData)
      .filter(item => 
        item !== null && 
        item !== undefined && 
        !(typeof item === 'object' && !Array.isArray(item) && Object.keys(item).length === 0) && // Remove empty objects
        !(Array.isArray(item) && item.length === 0) // Remove empty arrays
      );

    // Return null for empty arrays
    return cleanedArray.length > 0 ? cleanedArray : null;
  }

  if (typeof data === 'object' && data !== null) {
    const cleanedObject = Object.entries(data)
      .reduce((acc, [key, value]) => {
        const cleanedValue = cleanData(value);
        if (cleanedValue !== null && cleanedValue !== undefined && cleanedValue !== '') {
          acc[key] = cleanedValue;
        }
        return acc;
      }, {});

    // Return null for empty objects
    return Object.keys(cleanedObject).length > 0 ? cleanedObject : null;
  }

  // Remove null, undefined, and empty strings
  return data !== null && data !== undefined && data !== '' ? data : null;
};

export const handlePolicyDownload = (event, url, filename) => {
  event.preventDefault();
  const link = document.createElement('a');
  link.href = url; // The path to the PDF
  link.download = filename; // Set the filename for download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // Clean up
};

export const sortByCreatedAt = (data) => {
  if (!data || data.length === 0) {
    return [];
  }

  return data.sort((a, b) => {
    const dateDifference = new Date(b.createdAt) - new Date(a.createdAt);
    
    if (dateDifference !== 0) {
      return dateDifference; // Sort by createdAt first
    }

    return 0;
  });
}
// Function to extract only required key values
export const extractRequiredKeys = (array, keys) => {
  return array.map(obj => {
    let newObj = {};
    keys.forEach(key => {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  });
};

export const exportModifyDateTime = (dateVal) => {
  const year = new Date(dateVal).getFullYear();
  return (year !== 1) ? moment(dateVal).format('DD-MM-YYYY HH:MM:SS') : '-';
}
export const exportDateFormat= (dateVal) => {
  const year = new Date(dateVal).getFullYear();
  return (year !== 1) ? moment(dateVal).format('DD-MM-YYYY') : '-';
}

// Function to calculate the UTC offset in hours and minutes for a given timezone
export const calculateUTCOffset = (timeZone) => {
  const now = new Date();
  
  // Get UTC representation of the current time
  const utcDate = new Date(now.toLocaleString("en-US", { timeZone: "UTC" }));
  
  // Get target timezone representation of the current time
  const tzDate = new Date(now.toLocaleString("en-US", { timeZone }));

  // Get the difference in milliseconds and convert to minutes
  const offsetInMinutes = (tzDate.getTime() - utcDate.getTime()) / (1000 * 60);

  // Calculate hours and minutes
  let hours = Math.floor(Math.abs(offsetInMinutes) / 60);
  let minutes = Math.round(Math.abs(offsetInMinutes) % 60);

  // If minutes are 60 or more, carry over to hours
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  const sign = offsetInMinutes >= 0 ? "+" : "-";

  // Return formatted offset, padding hours and minutes
  return `UTC${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

  // Function to format time zones with UTC/GMT offsets and short names
  export const getTimeZoneOptions = () => {
    const timeZoneList = Intl.supportedValuesOf('timeZone');
    
    // Add UTC+00:00 manually to the list
    const timeZonesWithUTC = timeZoneList.map((tz) => {
        const utcOffset = calculateUTCOffset(tz);
        const label = `${utcOffset} (${tz})`;
        return { label, value: tz };
    });

    return timeZonesWithUTC;
};

export const pdfDownload = (content, headerText, fileName) => {
  const canvas = html2canvas(content, { scale: 2 });
  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const margin = 5;
  const headerHeight = 20;
  const contentStartPosition = headerHeight + 10;
  const pageContentHeight = pdfHeight - contentStartPosition - margin; // Height available for content on each page

  let imgHeight = (canvas.height * pdfWidth) / canvas.width; // Scale the image height to fit PDF width
  let position = 0; // Initial position to start rendering content

  pdf.setFontSize(10);
  pdf.text(headerText, margin, headerHeight); // Add header text on the first page

  while (position < imgHeight) {
    // Calculate the height of the remaining content to render
    const remainingHeight = imgHeight - position;
    const renderHeight = Math.min(pageContentHeight, remainingHeight); // Render only content that fits on the current page

    // Create a portion of the canvas for the current page's content
    const canvasPart = document.createElement('canvas');
    const context = canvasPart.getContext('2d');
    canvasPart.width = canvas.width;
    canvasPart.height = Math.min(remainingHeight, pageContentHeight) * (canvas.width / pdfWidth); // Scale canvas part height

    // Draw the current portion of the original canvas
    context.drawImage(
      canvas,
      0,
      position * (canvas.width / pdfWidth), // Start Y position on the original canvas
      canvas.width,
      renderHeight * (canvas.width / pdfWidth), // Height to draw from the original canvas
      0,
      0,
      canvasPart.width,
      canvasPart.height
    );

    const partImgData = canvasPart.toDataURL("image/png");

    pdf.addImage(partImgData, "PNG", margin, contentStartPosition, pdfWidth - 2 * margin, renderHeight);

    position += renderHeight; // Move position to the next page

    if (position < imgHeight) {
      pdf.addPage(); // Add new page if there's more content
      pdf.setFontSize(10); // Reset the font size for the new page
      pdf.text(headerText, margin, headerHeight); // Add header on each new page
    }
  }

  pdf.save(`${fileName}.pdf`);
}

export const getPlainText = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent !== 'null' &&  doc.body.textContent ? textSanitize(doc.body.textContent)?.trim().length : 0;
};
export const getPlainTextVal = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent !== 'null' &&  doc.body.textContent ? textSanitize(doc.body.textContent)?.trim() : '';
};
export const getValidRouteName = (routename, type = '') => {
  if (routename?.includes("conversation/alert")) {
    const match = routename.match(/conversation\/alert\/([A-Za-z0-9-]+)\/group\/(\d+)/);
    if(match?.length >= 2){
      const alertId = match[1]; // "1"
      const groupId = match[2]; // "3"
      const url = `/alert-details/${alertId}?group=${groupId}`;
      return url
    }
  } else if (routename?.includes("group/")) {
    const match = routename.match(/conversation\/(\d+)\/group\/(\d+)/);
    if(match?.length >= 2){
      const conversationID = match[1]; // "1"
      const groupId = match[2]; // "3"
      let url = `/conversations?group=${groupId}&conversation=${conversationID}`;
      if (routename.includes("from=audit-log")) {
        url += "&from=audit-log";
      }
      return url
    }
  } else if (routename?.includes("comment/")) {
    const match = routename.match(/alert\/([A-Za-z0-9-]+)\/comment\/(\d+)/);
    if(match?.length >= 2){
      const alertId = match[1]; // "1"
      const url = `/alert-details/${alertId}?open=commentPanel`;
      return url
    }
  }
  return !type ? routename : false;

}
export const textSanitize = (text) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value ? DOMPurify.sanitize(textarea.value): "";
}
export const dompurifyText = (text) => {
  return text ? DOMPurify.sanitize(text) : "";
};
export const decodeHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
export const handleNumericInput = (e) => {
  const { value } = e.target;
  const numericValue = value.replace(/[^0-9]/g, ''); // Only allow numeric characters
  e.target.value = numericValue;
};
export const exportFile = async (divId, exportType, downloadedFilename) => {
  const divElement = document.getElementById(divId);

  if (!divElement) {
    console.error("Div not found");
    return;
  }

  try {
    const canvas = await html2canvas(divElement, {
      scale: 2,
      backgroundColor: null, // Ensure transparency
    });
    // Convert the canvas to a base64 image
    const base64Image = canvas.toDataURL("image/png");

    if (exportType === "png") {
      const link = document.createElement("a");
      link.href = base64Image;
      link.download = `${downloadedFilename}.png`;
      link.click(); // Trigger download
    } else if (exportType === "pdf") {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      // Calculate PDF dimensions and scale the image
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pdfWidth / canvasWidth, pdfHeight / canvasHeight);
      const imgWidth = canvasWidth * ratio;
      const imgHeight = canvasHeight * ratio;

      const topMargin = 10;
      pdf.addImage(base64Image, "PNG", 0, topMargin, imgWidth, imgHeight);

      pdf.save(`${downloadedFilename}.pdf`);
    } else {
      console.error("Invalid export type. Use 'png' or 'pdf'.");
    }
  } catch (error) {
    console.error("Error exporting:", error);
  }
};
export const editorConfig = {
  modules: {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link']
    ],
    clipboard: {
      matchVisual: false // Prevents Quill from wrapping content in extra <p> tags
    }
  },
  formats: [
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent', 'link'
  ]
}

export const validationMessages = {
  sizeExceed: `File should be less than ${fileUploadLimit.label}`,
  imageSizeExceed: `Image should be less than ${fileUploadLimit.label}`,
  onlyImage: 'Only image files are allowed',
  maxFiles: `(Add up to ${maxNumberOfFiles} files less than ${fileUploadLimit.label} each)`,
  maxNumberOfFiles: `You can upload a maximum of ${maxNumberOfFiles} files (including existing and new files).`,
  newsFileTypes: 'Zip, Image, PDF, DOCX or XLSX files are allowed',
  allFileTypes: 'Image, PDF, DOCX or XLSX files are allowed',
  allFileTypesWithoutImage: 'PDF, DOCX or XLSX files are allowed',
  allTypes: 'PDF, DOC, DOCX, XLS, XLSX, CSV, PNG, JPG or JPEG files are allowed',
  uniqueFileNames: 'File names must be unique. Please rename your file(s) before uploading.'
}

export const numberFormat = (value = 0, fractions = 2) =>{
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: fractions,
    maximumFractionDigits: fractions,
  });
}
export const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || '$';
export const currencySymbolsByGroupId = {
  80: '$',
};

export const getCurrencySymbolByGroupId = (groupId) => {
  return currencySymbolsByGroupId[Number(groupId)] || currencySymbol;
};

export const currencyFormat = (value = 0, groupId, fractions = 2) => {
  const numericValue = Number(value) || 0;
  const sign = numericValue < 0 ? '-' : '';
  return `${sign}${getCurrencySymbolByGroupId(groupId)}${numberFormat(Math.abs(numericValue), fractions)}`;
}

export const toatlFormatAbbreviated = (value) => {
  const absValue = Math.abs(value);
  let formatted = '';

  if (absValue >= 1e9) {
    formatted = (absValue / 1e9).toFixed(2) + 'B';
  } else if (absValue >= 1e6) {
    formatted = (absValue / 1e6).toFixed(2) + 'M';
  } else if (absValue >= 1e3) {
    formatted = (absValue / 1e3).toFixed(2) + 'k';
  } else {
    formatted = absValue ? absValue?.toFixed(2): '0';
  }
  return formatted;
}

export const currencyFormatAbbreviated = (value = 0, groupId) => {
  const numericValue = Number(value) || 0;
  const sign = numericValue < 0 ? '-' : '';
  return `${sign}${getCurrencySymbolByGroupId(groupId)}${toatlFormatAbbreviated(numericValue)}`;
}

export const cappedDate = (date) => {
  const localDate = new Date(date);
  localDate.setHours(0, 0, 0, 0); // strip time for comparison
  const capped = new Date(Math.min(localDate.getTime(), maxDate.getTime()));
  capped.setHours(0, 0, 0, 0); // normalize result to start of day
  return capped;
}
export const predefinedRanges = [
  {
    label: 'Last 7 days',
    value: [
      new Date(subDays(maxDate, 6).setHours(0, 0, 0, 0)),
      new Date(maxDate.setHours(23, 59, 59, 999))
    ],
    placement: 'left'
  },
  {
    label: 'Last 30 days',
    value: [
      new Date(subDays(maxDate, 29).setHours(0, 0, 0, 0)),
      new Date(maxDate.setHours(23, 59, 59, 999))
    ],
    placement: 'left'
  },
  {
    label: 'This month',
    value: [
      new Date(startOfMonth(new Date()).setHours(0, 0, 0, 0)),
      new Date(cappedDate(new Date()).setHours(23, 59, 59, 999))
    ],
    placement: 'left'
  },
  {
    label: 'Last month',
    value: [
      new Date(startOfMonth(addMonths(new Date(), -1)).setHours(0, 0, 0, 0)),
      new Date(endOfMonth(addMonths(new Date(), -1)).setHours(23, 59, 59, 999))
    ],
    placement: 'left'
  },
  {
    label: 'This year',
    value: [
      new Date(new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0)),
      new Date(cappedDate(new Date()).setHours(23, 59, 59, 999))
    ],
    placement: 'left'
  },
  {
    label: 'Last year',
    value: [
      new Date(new Date(new Date().getFullYear() - 1, 0, 1).setHours(0, 0, 0, 0)),
      new Date(new Date(new Date().getFullYear(), 0, 0).setHours(23, 59, 59, 999))
    ],
    placement: 'left'
  },
  {
    label: 'Clear',
    value: [
      new Date(cappedDate(new Date()).setHours(0, 0, 0, 0)),
      new Date(cappedDate(new Date()).setHours(0, 0, 0, 0))
    ],
    placement: 'left'
  }
];

export const processCategories = (data = []) => {
  return data?.map(categoryItem => {
      const originalLinks = Array.isArray(categoryItem.links) ? categoryItem.links : [];
      const urlLinks = originalLinks
          .filter(link => !!link.url && !link.file?.key)
          .sort((a, b) => a.id - b.id);

      const fileLinks = originalLinks
          .filter(link => !!link.file?.key)
          .sort((a, b) => a.id - b.id);

      return {
          ...categoryItem,
          links: [...urlLinks, ...fileLinks],
      };
  });
};

// Adding https:// to www links and add target=_blank to <a> tags
export const processHtmlLinks = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const links = doc.querySelectorAll('a');
  links.forEach((link) => {
    const href = link.getAttribute('href') || '';

   // Add https:// to www links or links without http/https
    if (href.startsWith('www.') || !href.includes('http')) {
      link.setAttribute('href', `https://${href}`);
    }

    // Add target and rel
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  return DOMPurify.sanitize(doc.body.innerHTML, {
    ADD_ATTR: ['target', 'rel']
  });
};

export const trimFileName = (name) => {
  if (!name) return "";
  if (name.length <= filenameLimit) return name;
  
  const dotIndex = name.lastIndexOf(".");
  if (dotIndex === -1) {
    return name.slice(0, filenameLimit) + "...";
  }
  const ext = name.slice(dotIndex);
  const base = name.slice(0, dotIndex);

  return base.slice(0, filenameLimit - ext.length - 3) + "..." + ext;
}
export const theme = {
    main: 'line-height:1.3;color:#0D58BC;overflow:auto;',
    error: 'line-height:1.3;color:#0D58BC;overflow:auto;',
    key: 'color:#BE5055;',
    string: 'color:#fd971f;',
    value: 'color:#148611;',
    boolean: 'color:#ac81fe;',
};
